module.exports = "<companies-page></companies-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appFleet/companies.html
// module id = 1337
// module chunks = 0